'use strict';

angular.module('shiftTraderApp')
  .controller('SetupTradeCtrl', function ($scope, $rootScope, $timeout, ShiftTradesResource, Users, TradeRecommendations, workPeriod, me, mode) {
    $rootScope.$broadcast('setTopNavTitle', 'Trade My Shift');
    $scope.me = me;
    $scope.workPeriod = workPeriod;
    $scope.mode = mode;

    //set true once all user's information queried is returned and processed
    // used for showing/hiding progress/completion messages to the user
    $scope.workPeriodsForTradingLoaded = false;

    TradeRecommendations.getTradeRecForWpId($scope.workPeriod.id)
      .then(function(tr) {
        $scope.tradeRecommendation = tr;
        $scope.workPeriodsToDisplay = tr.workPeriods;
        $scope.workPeriodsForTradingLoaded = true;
      }, function() {
        console.log('whoops! TradeRecommendations wouldnt load');
      });

  });
